// login
// export const fetchOTPEndPoint = 'user-signup/login/';
// export const validateOtp = 'user-signup/validate/';
export const fetchTokenEndPoint = "users/tokens/v1/";

/*  login otp verification */

export const fetchOTPEndPoint = "users/send/otp/v1/";
export const validateOtp = "users/submit/otp/v1/";

// home checkout endpoint
// export const checkoutEndPoint = 'checkout/pd/v1/';
export const checkoutEndPoint = "checkout/pd/v1/order/";
export const otherCheckoutEndPoint = "checkout/payment-gateway/pd/v1/";
// export const otherCheckoutEndPoint = 'checkout/pd/v1/payment-mode/';
// export const otherCheckoutEndPoint = 'checkout/pd/v1/';
// export const getCheckoutStatusEndpoint = 'checkout_status/pd/v1/';
export const getCheckoutStatusEndpoint = "checkout/pd/v1/order-status/";

export const fetchMachineDetailEndPoint = "machine/details/";
export const fetchProductOfferIdEndPoint = "mpo/details/";
export const fetchIpEndPoint = "ip_address/";
export const fetchProductDetailEndpoint = "product/details/";
export const fetchOfferDetailEndPoint = "offer/details/";

export const getOfferListEndpoint = "digital-offers/";
export const offerLoadingEventEndpoint = "event-data/";
export const productLoadingEventEndpoint = "event-data/";

export const sendPaymentModeEventEndpoint = "checkout/pd/v1/payment-mode/";
export const generatePinEndpoint = "generate-pin/dispense/";

/* contest */
export const fetchContestEndpoint = "contest/rules/v1/";
export const fetchContestQuestionEndpoint = "quiz/get/questions/v1/";
export const submitContestQuestionEndpoint = "quiz/submit/questions/v1/";
export const fetchWinnerDetailEndpoint = "users/upi/info/v1/";
export const submitUpiDetailEndpoint = "users/submit/upi/v1/";
export const updateQuizWinnerDetailsEndpoint = "user/update/user/winner/v1";

/* Offers */
export const homeOffersEndpoint = "digital_offers/v1/";
export const categoriesEndpoint = "digital_offers/category/v1/";
export const CarouselEndpoint = "digital_offers/carousel/v1/";
export const hotDealsProductsEndpoint = "digital_offers/products/v1/";

export const contactUsEndpoint = "whatsapp/webhook/code/v1/";
